module.exports = __webpack_public_path__ + "img/add_terms.6d7dcf00.png";